import { RegisterForm } from '@/features/auth';
import { Box } from '@/shared/ui';

export const RegisterPage = () => {
  return (
    <Box sx={{ maxWidth: 443, width: '100%', mt: 3 }}>
      <RegisterForm />
    </Box>
  );
};
